export function split(string: string): string[] {
  return string.split('');
}
